const MQTT_MODE = {
  LOCAL: 'local',
  EXTERNAL: 'external'
};

const SETUP_MODES = {
  LOCAL: 'local',
  REMOTE: 'remote'
};

const ADAPTER_MODE = {
  USB: 'usb',
  NETWORK: 'network'
};

export { MQTT_MODE, SETUP_MODES, ADAPTER_MODE };
